/**
 * Detecção de staleness do cache local de config (ADR-0069).
 *
 * `fresh` < 7 dias · `warning` 7-30 dias · `critical` ≥ 30 dias.
 * Caller (ConfigClient) usa `critical` para forçar `DEFAULT_CONFIG`.
 */
import { createLogger, days } from '@planuze/kernel';
import type { RemoteConfig } from '../schema/schema.js';

const log = createLogger('config.stale');

const WARN_AGE_DAYS = 7;
const FATAL_AGE_DAYS = 30;
const MS_PER_DAY = days(1);

export type StaleStatus = 'fresh' | 'warning' | 'critical';

export function checkStaleness(config: RemoteConfig, nowMs: number = Date.now()): StaleStatus {
  if (config.generatedAt === 0) return 'fresh';
  const age = nowMs - config.generatedAt;
  if (age >= days(FATAL_AGE_DAYS)) {
    log.warn('config.stale.critical', { ageDays: Math.floor(age / MS_PER_DAY) });
    return 'critical';
  }
  if (age >= days(WARN_AGE_DAYS)) {
    log.warn('config.stale.warning', { ageDays: Math.floor(age / MS_PER_DAY) });
    return 'warning';
  }
  return 'fresh';
}
